module.exports = __webpack_public_path__ + "img/no-data-alt.b7dfb3ba.svg";